import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";
import { useAccount } from "wagmi";

import { Checkbox } from "@/components/ui/checkbox";

import Login from "./Login";

export const PushNotifications = () => {
  const [loading, setLoading] = useState(true);
  const { address } = useAccount();
  const { data: session } = useSession();

  const [checkboxes, setCheckboxes] = useState({
    notify_rank_change: false,
    notify_new_track: false,
    notify_new_features: false,
  });

  useEffect(() => {
    if (!address) return;
    fetch(`/api/notifications?address=${address}`)
      .then((response) => response.json())
      .then((data) => setCheckboxes(data))
      .finally(() => setLoading(false));
  }, [address]);

  const handleCheckboxChange = async (
    checkboxName: string,
    newValue: boolean | string
  ) => {
    const prevVal = { ...checkboxes };
    const newVal = { ...checkboxes, [checkboxName]: newValue };
    setCheckboxes(newVal);

    const response = await fetch("/api/notifications/edit", {
      method: "POST",
      body: JSON.stringify({ ...newVal, address }),
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      setCheckboxes(prevVal);
    }
  };

  return session ? (
    <>
      <p className="text-lg text-center " style={{ width: 40, lineHeight: 1 }}>
        Alert
        <br />
        For
      </p>
      {loading ? (
        <div className="flex justify-center">
          <div className="animate-spin rounded-full h-8 w-8"></div>
        </div>
      ) : (
        <>
          <div className="items-center flex space-x-2">
            <Checkbox
              id="notify_rank_change"
              checked={checkboxes.notify_rank_change === true}
              onCheckedChange={(checked) =>
                handleCheckboxChange("notify_rank_change", checked)
              }
            />
            <div className="grid gap-1.5 leading-none">
              <label
                htmlFor="notify_rank_change"
                className="text-md  leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Top 10 Change
              </label>
            </div>
          </div>
          <div className="items-center flex space-x-2">
            <Checkbox
              id="notify_new_track"
              checked={checkboxes.notify_new_track === true}
              onCheckedChange={(checked) =>
                handleCheckboxChange("notify_new_track", checked)
              }
            />
            <div className="grid gap-1.5 leading-none">
              <label
                htmlFor="notify_new_track"
                className="text-md leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                New Track
              </label>
            </div>
          </div>
          <div className="items-center flex space-x-2">
            <Checkbox
              id="notify_new_features"
              checked={checkboxes.notify_new_features}
              onCheckedChange={(checked) =>
                handleCheckboxChange("notify_new_features", checked)
              }
            />
            <div className="grid gap-1.5 leading-none">
              <label
                htmlFor="notify_new_features"
                className="text-md leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                New Features
              </label>
            </div>
          </div>
        </>
      )}
    </>
  ) : (
    <div className="flex flex-col w-full">
      <p className="text-lg">Sign in to manage notifications</p>
      <Login />
    </div>
  );
};
